let messaages_es_mx = {
	Salutation: {
		required: 'Por favor, seleccione un saludo.',
	},
	FirstName: {
		required: 'Introduzca un nombre.',
	},
	LastName: {
		required: 'Introduce un apellido.',
	},
	Email: {
		required: 'Introduce una dirección de correo electrónico.',
		email: 'Introduce una dirección de correo electrónico válida.',
	},
	Country: {
		required: 'Seleccione un país.',
	},
	Postcode: {
		required: 'Seleccione un código postal.',
	},
	Password: {
		required: 'Introduzca una contraseña.',
	},
	ConfirmPassword: {
		required: 'Introduzca una contraseña para confirmarlo.',
		equalTo: 'Asegúrese de que las contraseñas coinciden.',
	},
	TermsAndConditions: {
		required: 'Por favor, acepte los términos y condiciones.',
	}
};

export function messages_es_mx() {
	return messaages_es_mx;
}
